import {viewerExtensions, ViewerExtensionFactory} from '@wix/document-manager-extensions'
import {extensionLoader} from '@wix/document-manager-host-common'
import type {HostWithViewerManager} from './host'

const {loadExtensions} = extensionLoader

const loadViewerExtensions = (host: HostWithViewerManager) => {
    const {documentManager, viewerManager, config: dsConfig, environmentContext} = host
    const {experimentInstance, logger} = documentManager

    const extensionsToRegister: ViewerExtensionFactory[] = [
        viewerExtensions.viewerExtension,
        viewerExtensions.displayedStructure,
        viewerExtensions.refComponents,
        viewerExtensions.scopes,
        viewerExtensions.scopesMetaData,
        viewerExtensions.patterns,
        viewerExtensions.remeasure
    ]

    for (const extensionToRegister of extensionsToRegister) {
        const extension = extensionToRegister.createExtension({
            viewerManager,
            experimentInstance,
            environmentContext,
            dsConfig,
            logger
        })
        documentManager.registerExtension(extension)
    }
}

export {loadExtensions, loadViewerExtensions}
